/*
 * @Describe:
 * @Author: chenz
 */
const callHandler = (method, args, cb) => {
    var ret = ''
    if (typeof args == 'function') {
        cb = args
        args = {}
    }
    var arg = { data: args === undefined ? null : args }
    if (typeof cb == 'function') {
        var cbName = 'dscb' + window.dscb++
        window[cbName] = cb
        arg['_dscbstub'] = cbName
    }
    arg = JSON.stringify(arg)

    //if in webview that dsBridge provided, call!
    if (window.flutter_inappwebview) {
        // ret = _dsbridge.call(method, arg)
        if (window.flutter_inappwebview.callHandler) {
            ret = window.flutter_inappwebview.callHandler('' + method, arg)
        }
    } else if (window._dswk || navigator.userAgent.indexOf('_dsbridge') != -1) {
        ret = prompt('_flutterDsbridge=' + method, arg)
    }
    // //TODO  待商榷 可优化
    // this.registerHandler("CommonResult", cb);
    // this.registerHandler("CommonRequest", cb);

    /**
     * @description flutter桥接存在部分ret为Promise的情况,导致JSON.parse异常,暂时不清楚callHandler的用意
     */
    if (ret instanceof Promise) {
        return ret
    }

    try {
        return JSON.parse(ret || '{}').data
    } catch (error) {
        console.error('callHandle异常,JSON.parse错误')
    }
}

/** 桥接准备完成 */
const flutterDSBridgeIsReady = () => {
    if (window.navigator.userAgent.includes('Android')) {
        return window.flutter_inappwebview && window.flutter_inappwebview._platformReady
    }
    return true
}

const insertInCache = (() => {
    const cache = []
    const stophandle = setInterval(() => {
        if (!flutterDSBridgeIsReady()) {
            return
        }

        clearInterval(stophandle)
        cache.forEach((params) => {
            callHandler.apply(window, params)
        })
        cache.length = 0
    }, 500)

    return (...params) => {
        cache.push(params)
    }
})()

var bridge = {
    default: this, // for typescript
    callHandler: function (method, args, cb) {
        if (flutterDSBridgeIsReady()) {
            return callHandler(method, args, cb)
        }

        return insertInCache(method, args, cb)
    },
    register: function (name, fun, asyn) {
        var q = asyn ? window._dsaf : window._dsf
        if (!window._dsInit) {
            window._dsInit = true
            //notify native that js apis register successfully on next event loop
            setTimeout(function () {
                bridge.callHandler('_dsb.dsinit')
            }, 0)
        }
        if (typeof fun == 'object') {
            q._obs[name] = fun
        } else {
            q[name] = fun
        }
    },
    registerHandler: function (name, fun) {
        this.register(name, fun, true)
    },
}

!(function () {
    if (window._dsf) return
    var ob = {
        //保存JS同步方法
        _dsf: {
            _obs: {},
        },
        //保存JS异步方法
        _dsaf: {
            _obs: {},
        },
        dscb: 0,
        jsBridge: bridge,
        _handleMessageFromNative: function (info) {
            var arg = JSON.parse(info.data)
            var ret = {
                id: info.callbackId,
                complete: true,
            }
            var f = this._dsf[info.method]
            var af = this._dsaf[info.method]
            var callSyn = function (f, ob) {
                ret.data = f.apply(ob, arg)
                bridge.callHandler('_dsb.returnValue', ret)
            }
            var callAsyn = function (f, ob) {
                arg.push(function (data, complete) {
                    ret.data = data
                    ret.complete = complete !== false
                    bridge.callHandler('_dsb.returnValue', ret)
                })
                f.apply(ob, arg)
            }
            if (f) {
                callSyn(f, this._dsf)
            } else if (af) {
                callAsyn(af, this._dsaf)
            } else {
                //with namespace
                var name = info.method.split('.')
                if (name.length < 2) return
                var method = name.pop()
                var namespace = name.join('.')
                var obs = this._dsf._obs
                var ob = obs[namespace] || {}
                var m = ob[method]
                if (m && typeof m == 'function') {
                    callSyn(m, ob)
                    return
                }
                obs = this._dsaf._obs
                ob = obs[namespace] || {}
                m = ob[method]
                if (m && typeof m == 'function') {
                    callAsyn(m, ob)
                    return
                }
            }
        },
    }
    for (var attr in ob) {
        window[attr] = ob[attr]
    }
})()

module.exports = bridge;